// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expand-wrapper {
  transition: max-height 0.4s ease-in-out;
  overflow: hidden;
  height: auto;
}

.collapsed {
  max-height: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/expandable/expandable.component.scss"],"names":[],"mappings":"AAAA;EACI,uCAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEE;EACE,wBAAA;AACJ","sourcesContent":[".expand-wrapper {\r\n    transition: max-height 0.4s ease-in-out;\r\n    overflow: hidden;\r\n    height: auto;\r\n  }\r\n  \r\n  .collapsed {\r\n    max-height: 0 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
